import { Result } from './result.js';

export class AlphabetUtils {
  private static readonly UPPER_ALPHA = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';
  private static readonly LOWER_ALPHA = 'abcdefghijklmnopqrstuvwxyz';
  private static readonly NUMERIC = '0123456789';
  private static readonly UPPER_ALPHA_NUMERIC = AlphabetUtils.UPPER_ALPHA + AlphabetUtils.NUMERIC;

  public static readonly RESTRICTED_ALPHA_NUMERIC = AlphabetUtils.generateRestrictedAlphabet();
  public static readonly FULL_ALPHA_NUMERIC = AlphabetUtils.NUMERIC + AlphabetUtils.UPPER_ALPHA + AlphabetUtils.LOWER_ALPHA;

  public static translate(source: string, sourceAlphabet: string, targetAlphabet: string, targetLength?: number | null | undefined): Result<string, string> {
    const sourceBase = sourceAlphabet.length;
    const targetBase = targetAlphabet.length;

    const sourceIntResult = this.wordToBigInt(source, sourceAlphabet);
    if(sourceIntResult.isError) {
      return Result.error(sourceIntResult.error);
    }

    const sourceInt = sourceIntResult.value;
    targetLength ??= this.findDigitCountInBase(sourceBase, source.length, targetBase);

    return this.bigIntToWord(sourceInt, targetAlphabet, targetLength);
  }

  public static getCardinalityOfLanguage(alphabet: string, length: number): bigint {
    return BigInt(alphabet.length) ** BigInt(length);
  }

  public static wordToBigInt(word: string, alphabet: string): Result<bigint, string> {
    const base = BigInt(alphabet.length);
    let result = BigInt(0);
    for(const char of word) {
      const digit = alphabet.indexOf(char);
      if(digit < 0) {
        return Result.error('The word contains characters not in the alphabet.');
      }

      result = result * base + BigInt(digit);
    }

    return Result.ok(result);
  }

  public static bigIntToWord(value: bigint, alphabet: string, length: number): Result<string, string> {
    const base = BigInt(alphabet.length);
    const result = [];
    for(let i = 0; i < length; i++) {
      const index = Number(value % base);
      result.unshift(alphabet[index]);
      value = value / base;
    }

    if(value > BigInt(0)) {
      return Result.error('The value is too large for the specified length.');
    }

    return Result.ok(result.join(''));
  }

  private static findDigitCountInBase(sourceBase: number, sourceDigitCount: number, targetBase: number): number {
    return Math.ceil(sourceDigitCount * Math.log(sourceBase) / Math.log(targetBase));
  }

  private static generateRestrictedAlphabet(): string {
    const alphabet = AlphabetUtils.UPPER_ALPHA_NUMERIC;
    const result = [];

    for(const char of alphabet) {
      if(char === 'B' || char === '8') {
        continue;
      }

      if(char === 'G' || char === '6') {
        continue;
      }

      if(char === 'I' || char === '1') {
        continue;
      }

      if(char === '0' || char === 'O' || char === 'D' || char === 'Q') {
        continue;
      }

      if(char === 'S' || char === '5') {
        continue;
      }

      if(char === 'Z' || char === '2') {
        continue;
      }

      // if(char === 'A' || char === '4') {
      //   continue;
      // }

      if(char === 'U' || char === 'V' || char === 'W') {
        continue;
      }

      // if(char === 'E' || char === 'F') {
      //   continue;
      // }

      // if(char === 'P' || char === 'R') {
      //   continue;
      // }

      // if(char === 'X' || char === 'Y') {
      //   continue;
      // }

      // if(char === 'H' || char === 'K') {
      //   continue;
      // }

      // if(char === 'M' || char === 'N') {
      //   continue;
      // }

      // if(char === 'T' || char === '7' || char === 'J') {
      //   continue;
      // }

      // if(char === '3' || char === '9') {
      //   continue;
      // }

      // if(char === 'C' || char === 'L') {
      //   continue;
      // }

      result.push(char);
    }

    return result.join('');
  }
}
